var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { PlayerState } from "./types";
import { PlayerContextConsumer } from "../context/player";
import { PAUSE_SMALL_WHITE_SVG, CLOSE_SVG, PLAY_SMALL_WHITE_SVG } from "../assets";
import PlaybackManager from "./PlaybackManager";
import { messages } from "../messages";
import { displayDate } from "../util/date";
var MediaListItem = /** @class */ (function (_super) {
    __extends(MediaListItem, _super);
    function MediaListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaListItem.prototype.onPause = function () {
        PlaybackManager.getInstance().pause();
    };
    MediaListItem.prototype.onPlay = function (album) {
        var nextTrack = PlaybackManager.getInstance().getContentManager().getTracks().find(function (t) { return t.album.id == album.id; });
        if (nextTrack)
            PlaybackManager.getInstance().startTrack(nextTrack, undefined, true);
    };
    MediaListItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, media = _a.media, album = _a.album, isPlaying = _a.isPlaying;
        return React.createElement(PlayerContextConsumer, null, function (playerContext) {
            return React.createElement("div", { className: "queue-row" },
                React.createElement("div", { className: 'col-play' }, React.createElement("a", { href: "javascript:void(0)", onClick: function (e) {
                        if (isPlaying) {
                            e.stopPropagation();
                            _this.onPause();
                        }
                        else {
                            e.stopPropagation();
                            _this.onPlay(album);
                        }
                    } },
                    !isPlaying && React.createElement("div", { className: 'play' },
                        React.createElement("img", { src: PLAY_SMALL_WHITE_SVG, className: 'play blue', width: 6 })),
                    isPlaying && React.createElement("div", { className: 'pause' },
                        React.createElement("img", { src: PAUSE_SMALL_WHITE_SVG, className: 'pause white', width: 6 })))),
                React.createElement("div", { className: "col-track" },
                    React.createElement("span", { style: { display: 'block' } }, album.name)),
                React.createElement("div", { className: "col-artist" }, album.artist),
                React.createElement("div", { className: "col-category" },
                    React.createElement("span", null, album.category.name)),
                React.createElement("div", { className: "col-bpm" },
                    React.createElement("span", null, album.bpm)),
                React.createElement("div", { className: "col-key" },
                    React.createElement("span", null, album.key || 'N/A')),
                React.createElement("div", { className: "col-date" },
                    React.createElement("span", null, displayDate(album.created_at))));
        });
    };
    return MediaListItem;
}(React.PureComponent));
var Queue = /** @class */ (function (_super) {
    __extends(Queue, _super);
    function Queue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Queue.prototype.close = function () {
        this.props.onClose && this.props.onClose();
    };
    Queue.prototype.render = function () {
        var _this = this;
        return React.createElement(PlayerContextConsumer, null, function (playerContext) {
            var isPlaying = playerContext.state >= PlayerState.Loading;
            var playlist = (playerContext.track ? PlaybackManager.getInstance().getContentManager().getTracksAfter(playerContext.track) : undefined);
            return React.createElement("div", { ref: _this.props.innerRef, className: _this.props.className || '', style: _this.props.style },
                React.createElement("div", { className: "listview" },
                    playerContext.track && React.createElement(React.Fragment, null,
                        React.createElement("h4", { style: { display: 'flex' } },
                            React.createElement("span", null, messages.CurrentSong),
                            React.createElement("div", { onClick: function (e) { return _this.close(); }, className: "close", style: { marginLeft: 'auto', textAlign: 'end' } },
                                React.createElement("img", { src: CLOSE_SVG, width: 12 }))),
                        React.createElement(MediaListItem, { media: playerContext.track.track, album: playerContext.track.album, isPlaying: isPlaying })),
                    playlist && React.createElement("div", { className: "next-songs" },
                        React.createElement("div", { className: "seperator" }),
                        React.createElement("h4", null, messages.NextSongs),
                        playlist.slice(0, 5).map(function (t) {
                            return React.createElement(MediaListItem, { media: t.track, album: t.album, isPlaying: false, key: t.album.id + '' + t.album.media[0].id });
                        }))));
        });
    };
    return Queue;
}(React.PureComponent));
export default Queue;
//# sourceMappingURL=Queue.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/player/Queue.js
// module id = 465
// module chunks = 0